import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MotesMapComponent } from './motes-map.component';

@NgModule({
    declarations: [MotesMapComponent],
    imports: [
        CommonModule
    ],
    exports: [MotesMapComponent]
})
export class MotesMapModule { }
